export default __webpack_public_path__ + "static/media/ethIcon.23ca4a5f.png";